// All needed imports
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PresentersModule } from '../presenters/presenters.module';
import { CalcBudgetStepOneComponent } from './calc-budget-step-one/calc-budget-step-one.component';
import { CalcBudgetStepTwoComponent } from './calc-budget-step-two/calc-budget-step-two.component';
import { StepsThanksComponent } from './step-thanks/steps-thanks.component';
import { StepsMenuComponent } from './steps-menu/steps-menu.component';

import { LegalStepOneComponent } from './legal-step-one/legal-step-one.component';
import { LegalStepTwoComponent } from './legal-step-two/legal-step-two.component';
import { LegalStepThreeComponent } from './legal-step-three/legal-step-three.component';
import { LegalStepThreeRentComponent } from './legal-step-three-rent/legal-step-three-rent.component';

import {DialogModule} from 'primeng/dialog';
import {AccordionModule} from 'primeng/accordion';
import { InsuredListDataComponent } from './insured-list-data/insured-list-data.component';
import { InsuredDataComponent } from './insured-data/insured-data.component';
import { EmergencyContactComponent } from './emergency-contact/emergency-contact.component';
import { UtilsService } from '../../services/utils/utils.service';
import { StudentsStepOneComponent } from './students-step-one/students-step-one.component';

@NgModule( {
  // Declarate the needed components
  declarations: [
    CalcBudgetStepOneComponent,
    CalcBudgetStepTwoComponent,
    StepsMenuComponent,
    InsuredDataComponent,
    InsuredListDataComponent,
    EmergencyContactComponent,
    StepsThanksComponent,
    LegalStepOneComponent,
    LegalStepTwoComponent,
    LegalStepThreeComponent,
    LegalStepThreeRentComponent,
    StudentsStepOneComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    PresentersModule,
    DialogModule,
    AccordionModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    CalcBudgetStepOneComponent,
    CalcBudgetStepTwoComponent,
    StepsMenuComponent,
    InsuredDataComponent,
    InsuredListDataComponent,
    EmergencyContactComponent,
    StepsThanksComponent,
    LegalStepOneComponent,
    LegalStepTwoComponent,
    LegalStepThreeComponent,
    LegalStepThreeRentComponent,
    TranslateModule,
    StudentsStepOneComponent
  ],
  // Declarate the services used
  providers: [ UtilsService ]
} )
/**
 * Form Steps Module class
 */
export class FormsStepsModule { }
